import md5 from 'md5';

import ManagerRepository from 'coreClasses/ManagerRepository';
import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {ENewsletterSubscriptionSection} from '../../IGoogleTagManager';
import EventModel from '../EventModel';

/**
 * Represents NewsletterSubscriptionEventModel
 */
export default class NewsletterSubscriptionEventModel extends EventModel {
	public emailId: string;
	public nlSection: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.emailId = md5(data.email, {encoding: 'hex'}).toString();
		this.nlSection = data?.eventSource && ENewsletterSubscriptionSection[EEventSource[data.eventSource]];
	}
};
